import { render, staticRenderFns } from "./BookTravel.vue?vue&type=template&id=cf36133e&scoped=true&"
import script from "./BookTravel.vue?vue&type=script&lang=js&"
export * from "./BookTravel.vue?vue&type=script&lang=js&"
import style0 from "./BookTravel.vue?vue&type=style&index=0&id=cf36133e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf36133e",
  null
  
)

export default component.exports